/* global $ */
$(document).ready(function () {
    $('.show_more').on('click', function () {
        $(this).parent().parent().find('.city_shops_wrap').show(400, 'linear');
        $(this).remove();
    });
});
